export enum AggregationType {
    SUM = <any>"SUM"
}

export class ChartQueryRequestData {
    requestId: string;

    /**
     * Indicates that the request is being resent. The requestId should be the same as the previous attempt that
     * timed out
     */
    resubmission: boolean;

    cubeName: string;

    /**
     * List of fully qualified member names that filters or drills
     */
    dashboardFilterMembers: string[];

    chartFilterMembers: string[];

    chartMeasures: string[];

    /**
     * Base date range. Null is all dates
     */
    dateRangeRef: string;

    restrictedStartDate: string;

    restrictedEndDate: string;

    restrictedDateLevel: string;

    selectedRefLine: string;

    attribute: string;

    pinLevel: boolean;

    topCount: number;

    topBottomRef: string;

    aggregationType: AggregationType;

    drillLevel: number;

}
